var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{attrs:{"tip":"数据加载中...","spinning":_vm.loading}},[_c('div',{staticStyle:{"height":"300px","width":"400px"},attrs:{"id":"contentChart","loading":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }